import { filterProposals } from 'common/api/proposals';
import { formatDate, parseDate } from 'common/utils/dates';

import {
    FETCH_PROPOSALS,
    FETCH_PROPOSALS_FAILURE,
    FETCH_PROPOSALS_SUCCESS,
} from '../actionTypes';
import { proposalsActions } from '../reducer';

export default (filterData) => (dispatch) => {
    dispatch(proposalsActions[FETCH_PROPOSALS]());

    const {
        companyId,
        date_render_filter,
        final_date,
        initial_date,
        orderBy,
        page,
        pageSize,
        searchText,
        sortBy,
        status,
    } = filterData;

    const date_range_filter = `${formatDate(
        parseDate(initial_date, 'dd/MM/yyyy'),
        'yyyy-MM-dd',
    )},${formatDate(parseDate(final_date, 'dd/MM/yyyy'), 'yyyy-MM-dd')}`;

    filterProposals({
        companyId: companyId === 'all' ? '' : companyId,
        date_range_filter,
        date_render_filter,
        orderBy,
        page: page + 1,
        perPage: pageSize,
        searchText,
        sortBy,
        status,
    })
        .then((response) =>
            dispatch(proposalsActions[FETCH_PROPOSALS_SUCCESS](response.data)),
        )
        .catch((error) =>
            dispatch(
                proposalsActions[FETCH_PROPOSALS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
